/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import RoleToggle from "../../components/RoleToggle";
import WarehouseOne from "./_components/WarehouseOne";
import AddWarehouseModals from "./_components/AddWarehouseModals";
import { useWarehouseListData } from "../../apis/warehouseApi";
import RoleToggleSkeleton from "../../components/skeleton/ReactToggleSkeleton";
import WarehouseSkeleton from "../../components/skeleton/WarehouseSkeleton";
import { IconPlus } from "@tabler/icons-react";
import { useSelector } from "react-redux";
import ListView from "../../components/common/ListView";
import formatDate from "../../utilities/helper";
import { usePermission } from "../../hooks/usePermissionTabs";

const Warehouse: React.FC = () => {
  const [activeRole, setActiveRole] = useState<string>("");
  const [roles, setRoles] = useState<string[]>([]);
  const [activeIndex, setActiveIndex] = useState<number>(0);
  const [showModal, setShowModal] = useState(false);
  const profile = useSelector((state: any) => state.auth.profile);
  const { allowed: canCreateWarehouse } = usePermission("warehouse", "create");

  const {
    // data,
    isPending: listPending,
    refetch: warehouseRefetch,
  } = useWarehouseListData();

  const data = useSelector((state: any) => state?.warehouse.data);

  useEffect(() => {
    if (data && data?.warehouses?.length > 0) {
      const warehouseNames = data?.warehouses?.map((ele: any) => ele?.name);
      setRoles(warehouseNames);

      const savedRole = localStorage.getItem("WarehouseActiveRole");
      const validSavedRole = savedRole && warehouseNames.includes(savedRole);

      const initialRole = validSavedRole ? savedRole : warehouseNames[0];
      setActiveRole(initialRole);
    } else {
      setRoles([]);
      setActiveRole("");
    }
  }, [data]);

  useEffect(() => {
    if (activeRole) {
      localStorage.setItem("WarehouseActiveRole", activeRole);
    } else {
      localStorage.removeItem("WarehouseActiveRole");
    }
  }, [activeRole]);

  useEffect(() => {
    if (roles.length > 0 && activeRole) {
      const index = roles.findIndex((role) => role === activeRole);
      setActiveIndex(index >= 0 ? index : 0);
    } else {
      setActiveIndex(0);
    }
  }, [activeRole, roles]);

  useEffect(() => {
    if (!showModal) {
      // warehouseRefetch();
    }
  }, [showModal, warehouseRefetch]);

  return (
    <>
      <div className="p-6 pt-4 space-y-4 2xl:w-9/12 sxl:w-9/12 mx-auto">
        <div className="flex justify-between gap-4 items-center">
          {listPending ? (
            <RoleToggleSkeleton />
          ) : roles.length > 0 ? (
            <div className="whitespace-nowrap overflow-hidden overflow-x-auto  [&::-webkit-scrollbar]:h-2 [&::-webkit-scrollbar-track]:rounded-full [&::-webkit-scrollbar-track]:bg-gray-100 [&::-webkit-scrollbar-thumb]:rounded-full [&::-webkit-scrollbar-thumb]:bg-gray-300 dark:[&::-webkit-scrollbar-track]:bg-neutral-700 dark:[&::-webkit-scrollbar-thumb]:bg-neutral-500">
              <RoleToggle
                options={roles}
                active={activeRole}
                onChange={setActiveRole}
                translateOptions={false}
              />
            </div>
          ) : (
            <div className="text-sm text-gray-500">No warehouses found</div>
          )}

          {canCreateWarehouse && profile?.warehouseType !== 'SINGLE' && (
            <button
              onClick={() => setShowModal(true)}
              className="bg-[#FBD037] text-[#212121] text-sm font-semibold p-2 rounded-full"
            >
              <IconPlus stroke={1.5} size={20} />
            </button>
          )}
        </div>

        <div className="">
          {listPending ? (
            <WarehouseSkeleton />
          ) : data && data?.warehouses?.length > 0 ? (
            <WarehouseOne
              data={data?.warehouses?.[activeIndex]}
              warehouseRefetch={warehouseRefetch}
              isPending={listPending}
            />
          ) : (
            <div className="bg-[#FCFDF8] border border-[#D2D2D2] rounded-3xl p-8 flex flex-col items-center text-center">
              <img src="/img/scan-data.png" alt="no data" className="mb-4" />
              <h2 className="text-[#212121] text-lg font-medium">
                No Warehouse Found
              </h2>
              <p className="text-[#212121]/70 text-sm mb-4">
                Start by adding your first warehouse.
              </p>
              {canCreateWarehouse && (
                <button
                  onClick={() => setShowModal(true)}
                  className="bg-[#FBD037] hover:bg-yellow-400 text-[#000000] flex items-center gap-2 rounded-full px-6 py-2 text-sm font-medium"
                >
                  <IconPlus stroke={1.5} size={20} />
                  Add Warehouse
                </button>
              )}
            </div>
          )}
        </div>

        {data && data?.deactivatedWarehouses && data.deactivatedWarehouses.length > 0 && (
          <div className="space-y-4 border border-[#d2d2d2] rounded-[20px] bg-gradient-to-r from-[#FFFFFD] to-[#FDF8E5] bg-[#F7F6F2] shadow-sm p-4">
            <div className="flex justify-between items-center px-2">
              <h1 className="text-[#212121] font-medium text-lg">Deactivated Warehouses</h1>
            </div>
            <div className="overflow-hidden rounded-2xl border border-gray-200">
              <ListView
                mainDivClassName="bg-transparent p-0"
                mailDivClassName="p-0 bg-transparent"
                data={data.deactivatedWarehouses}
                columns={[
                  { label: "#", render: (_, i) => i + 1 },
                  { label: "Name", render: (wh: any) => wh.name },
                  { label: "Country", render: (wh: any) => wh.countryName },
                  { label: "City", render: (wh: any) => wh.cityName },
                  { label: "District", render: (wh: any) => wh.districtName },
                  { label: "Zip Code", render: (wh: any) => wh.zipCode },
                  { label: "Deactivated Date", render: (wh: any) => formatDate(wh.deletedAt) },
                  { label: "Short Address", render: (wh: any) => wh.shortAddress || "-" },
                ]}
              />
            </div>
          </div>
        )}
      </div>
      {showModal && <AddWarehouseModals onClose={() => setShowModal(false)} />}
    </>
  );
};
export default Warehouse;
